import type {ComponentType} from "react";
import {SettingsModuleNav, SettingsPermissionsSubNav, SettingsSubNav} from "../../../Enums";
import {XyiconFeature} from "../../../generated/api/base";
import {MyProfile} from "./myprofile/MyProfile";
import {OrganizationSettings} from "./organization/OrganizationSettings";
import {UsersView} from "./permissions/users/UsersView";
import {UserGroupsView} from "./permissions/usergroups/UserGroupsView";
import {PortfolioGroupsView} from "./permissions/portfoliogroups/PortfolioGroupsView";
import {PermissionSets} from "./permissions/permissionsets/PermissionSets";
import {ModuleSettings} from "./modules/ModuleSettings";

export interface ISettingsSubMenu {
	id: SettingsSubNav | SettingsModuleNav | SettingsPermissionsSubNav;
	label: string;
	component?: ComponentType<any>;
	props?: any;
	children?: ISettingsSubMenu[];
}

export const SettingsComponentTree: ISettingsSubMenu[] = [
	{
		id: SettingsSubNav.PERSONAL,
		label: "My Profile",
		component: MyProfile,
	},
	{
		id: SettingsSubNav.ORGANIZATION,
		label: "Organization",
		component: OrganizationSettings,
	},
	{
		id: SettingsSubNav.PERMISSIONS,
		label: "Permissions",
		children: [
			{
				id: SettingsPermissionsSubNav.USERS,
				label: "Users",
				component: UsersView,
			},
			{
				id: SettingsPermissionsSubNav.USER_GROUPS,
				label: "User Groups",
				component: UserGroupsView,
			},
			{
				id: SettingsPermissionsSubNav.PORTFOLIO_GROUPS,
				label: "Portfolio Groups",
				component: PortfolioGroupsView,
			},
			{
				id: SettingsPermissionsSubNav.PERMISSION_SETS,
				label: "Permission Sets",
				component: PermissionSets,
			},
		],
	},
	{
		id: SettingsSubNav.MODULES,
		label: "Modules",
		children: [
			{
				id: SettingsModuleNav.PORTFOLIO,
				label: "Portfolio",
				component: ModuleSettings,
				props: {
					feature: XyiconFeature.Portfolio,
					icon: "portfolio",
				},
			},
			{
				id: SettingsModuleNav.SPACE,
				label: "Space",
				component: ModuleSettings,
				props: {
					feature: XyiconFeature.Space,
					icon: "spaces",
				},
			},
			{
				id: SettingsModuleNav.CATALOG,
				label: "Catalog",
				component: ModuleSettings,
				props: {
					feature: XyiconFeature.XyiconCatalog,
					icon: "catalog",
				},
			},
			{
				id: SettingsModuleNav.XYICON,
				label: "Xyicon",
				component: ModuleSettings,
				props: {
					feature: XyiconFeature.Xyicon,
					icon: "xyicons",
				},
			},
			{
				id: SettingsModuleNav.BOUNDARY,
				label: "Boundary",
				component: ModuleSettings,
				props: {
					feature: XyiconFeature.Boundary,
					icon: "boundaries",
				},
			},
			// {
			// 	id: "event",
			// 	label: "Event",
			// 	component: ModuleSettings,
			// 	props: {
			// 		feature: XyiconFeature.Event
			// 	}
			// }
		],
	},
];

const getSettingsSubMenuById = (id: SettingsSubNav | SettingsPermissionsSubNav | SettingsModuleNav): ISettingsSubMenu => {
	const search = (items: ISettingsSubMenu[]): ISettingsSubMenu | undefined => {
		for (const item of items) {
			if (item.id === id) {
				return item;
			}
			if (item.children) {
				const subMenuMaybe = search(item.children);
				if (subMenuMaybe) {
					return subMenuMaybe;
				}
			}
		}
	};

	return search(SettingsComponentTree);
};

export const getSettingsComponentById = (id: SettingsSubNav | SettingsPermissionsSubNav | SettingsModuleNav): React.ReactElement<any, any> => {
	const subMenuMaybe = getSettingsSubMenuById(id);
	if (subMenuMaybe?.component) {
		const Component = subMenuMaybe.component;
		const props = subMenuMaybe.props || {};

		return <Component {...props} />;
	}

	console.warn(`SettingsView: No component found for id ${id}`);

	return <></>;
};
